<template>
  <f7-actions v-model:opened="isOpened" @actions:closed="onHide">
    <f7-actions-group>
      <f7-actions-label>{{ customerData.Name }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group class="row no-gap">
      <div class="actions-button col-50" @click="openAssets">
        <div class="actions-button-media">
          <i class="f7-icons icon-assets text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Assets') }}</div>
      </div>
      <div class="actions-button col-50" @click="openSubCustomers">
        <div class="actions-button-media">
          <i class="f7-icons icon-customers text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('SubCustomers') }}</div>
      </div>

      <div class="actions-button col-50" @click="openCustomerDetails">
        <div class="actions-button-media">
          <i class="f7-icons icon-customer-details text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('Details') }}</div>
      </div>
      <div class="actions-button col-50" @click="openResetPassword">
        <div class="actions-button-media">
          <i class="f7-icons icon-password text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('ResetPassword') }}</div>
      </div>

      <div class="actions-button col-50" @click="openDialogSuspend" :class="{disabled: customerData.State === 'Suspended'}">
        <div class="actions-button-media">
          <i class="f7-icons icon-deactivation text-color-red"></i>
        </div>
        <div class="actions-button-text">{{ $t('Suspend') }}</div>
      </div>
      <div class="actions-button col-50" @click="openDialogUnSuspend" :class="{disabled: customerData.State === 'Active'}">
        <div class="actions-button-media">
          <i class="f7-icons icon-activation text-color-green"></i>
        </div>
        <div class="actions-button-text">{{ $t('UnSuspend') }}</div>
      </div>

      <div class="actions-button col-50" @click="openTransferCredits">
        <div class="actions-button-media">
          <i class="f7-icons icon-menu-credits text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('TransferCredits') }}</div>
      </div>
      <div class="actions-button col-50" @click="openDialogSendRegLetter">
        <div class="actions-button-media">
          <i class="f7-icons icon-email text-color-lightgray"></i>
        </div>
        <div class="actions-button-text">{{ $t('SendRegLetter') }}</div>
      </div>

      <div class="actions-button col-100" @click="openDialogDelete" >
        <div class="actions-button-media">
          <i class="f7-icons icon-delete text-color-red"></i>
        </div>
        <div class="actions-button-text">{{ $t('Delete') }}</div>
      </div>
    </f7-actions-group>
  </f7-actions>
</template>

<script>


import { f7 } from 'framework7-vue';
import { mapGetters } from 'vuex'
import { ApiMethods, QTAPI } from "../../../services/qt-api";

export default {
  name: "asset-menu",

  props: {
    customerData: { type: Object, default: ()=> { return {} } },
    isOpened: { type: Boolean, default: false },
  },

  emits: ['update:isOpened'],

  data() {
    return {

    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'UserInfo'])
  },

  methods: {
    openAssets(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'assets',
        query: { customerName: this.customerData.Name, customerCode: this.customerData.Code },
      })
    },
    openCustomerDetails(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'customer-edit',
        query: { customerName: this.customerData.Name, customerCode: this.customerData.Code },
      })
    },
    openResetPassword(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'customer-reset-password',
      }, {
        props: { customerData: this.customerData }
      })
    },
    openSubCustomers(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'customers',
        query: { mainCustomerCode: this.customerData.Code, mainCustomerName: this.customerData.Name },
      })
    },
    openDialogSuspend(){
      this.onHide()
      f7.dialog.confirm(this.$t('CustomerSuspendDescription', { name: this.customerData.Name }), this.$t('Suspend'), async (dialog) => {

        let data = {
          MinorToken: this.MinorToken,
          MajorToken: this.MajorToken,
          csCode: this.customerData.Code,
        };

        f7.progressbar.show('green');
        const result = await QTAPI.CustomerSuspend(data)
        await f7.utils.nextTick()
        f7.progressbar.hide();
        if(!result){
          return
        }
        this.$store.commit('CUSTOMER_UPDATED')
        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('CustomerSuspended', { name: this.customerData.Name }),
          closeTimeout: 3000,
        }).open();

      });
    },
    openDialogUnSuspend(){
      this.onHide()
      f7.dialog.confirm(this.$t('CustomerUnSuspendDescription', { name: this.customerData.Name }), this.$t('UnSuspend'), async (dialog) => {

        let data = {
          MinorToken: this.MinorToken,
          MajorToken: this.MajorToken,
          csCode: this.customerData.Code,
        };

        f7.progressbar.show('green');
        const result = await QTAPI.CustomerUnSuspend(data)
        await f7.utils.nextTick()
        f7.progressbar.hide();
        if(!result){
          return
        }
        this.$store.commit('CUSTOMER_UPDATED')
        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('CustomerUnSuspended', { name: this.customerData.Name }),
          closeTimeout: 3000,
        }).open();

      });
    },
    openTransferCredits(){
      this.onHide()
      f7.views.main.router.navigate({
        name: 'credits-transfer',
        query: { customerName: this.customerData.Name, userCode: this.customerData.UserCode, customerEmail: this.customerData.Email },
      })
    },
    openDialogDelete(){
      this.onHide()
      f7.dialog.confirm(this.$t('CustomerDeleteDescription', { name: this.customerData.Name }), this.$t('Delete'), async (dialog) => {

        let data = {
          MinorToken: this.MinorToken,
          MajorToken: this.MajorToken,
          csCode: this.customerData.Code,
        };

        f7.progressbar.show('green');
        const result = await QTAPI.CustomerDelete(data)
        await f7.utils.nextTick()
        f7.progressbar.hide();
        if(!result){
          return
        }
        this.$store.commit('CUSTOMER_UPDATED')
        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('CustomerDeleted', { name: this.customerData.Name }),
          closeTimeout: 3000,
        }).open();

      });
    },
    async openDialogSendRegLetter(){
      this.onHide()

      f7.dialog.confirm(this.$t('SendRegLetterDescription', { name: this.customerData.Name, email: this.customerData.Email }), this.$t('SendRegLetter'), async (dialog) => {
        f7.progressbar.show('green');
        let fullCustomerData = await QTAPI.GetPreEditCustomerInfo({
          MajorToken: this.MajorToken,
          MinorToken: this.MinorToken,

          Code: this.customerData.Code
        });
        if(!fullCustomerData){
          f7.progressbar.hide();
          return
        }

        let result = await QTAPI.SendRegLetter({
          EMails: [fullCustomerData?.ContactInfo?.Mail],
          WebsiteCode: fullCustomerData?.CustomerInfo?.WebSiteCode,
          LoginName: fullCustomerData?.ContactInfo?.LoginName,
          CustomerCode: this.customerData.Code,
        })
        f7.progressbar.hide();

        if(!result) return

        f7.notification.create({
          subtitle: this.$t('Success'),
          text: this.$t('LetterSent'),
        }).open()
      });
    },

    onHide(){
      this.$emit('update:isOpened', false)
    },
  },

  mounted() {

  },



  beforeDestroy() {

  }
}
</script>